'use strict';

import React, { Component } from 'react';

import ListItemComponent from './ListItemComponent';
import globalConfig from '../../settings/config';

class ListComponent extends Component {
  constructor(props) {
    super(props);

    this.printListItems = this.printListItems.bind(this);
    this.handleSortOptionChange = this.handleSortOptionChange.bind(this);
  }

  printListItems() {
    // if (this.props.mapRef.zoom < 10) {
    //   return globalConfig.messages.tooManyResults;
    // }
    if (this.props.events.length == 0) {
      return globalConfig.messages.noResults;
    }

    const events = this.props.events;

    return events.map((item) => (
      <ListItemComponent
        event={item}
        key={`events-${item.center.lat}-${item.center.lng}`}
        mapRef={this.props.mapRef}
        mapApi={this.props.mapApi}
        handleMenuTabClick={this.props.handleMenuTabClick}
      />
    ));
  }

  handleSortOptionChange(e) {
    if (e.target.value != this.props.selectedSortOption) {
      this.props.handleEventsSort(e.target.value);
    }
  }

  render() {
    return (
      <div className="map-menu__panel map-menu__panel--active">
        <div className="events-list-header">
          <div className="events-list-collection">
            {this.props.selectedCollection
              ? this.props.selectedCollection
              : globalConfig.collections.default.displayName}
          </div>
          <div className="events-list-sort">
            <select
              onChange={this.handleSortOptionChange}
              value={this.props.selectedSortOption}
              title="events_sort_options"
            >
              <option value="metalocation">Name</option>
              <option value="date">Date</option>
            </select>
          </div>
        </div>
        <ul className="events-list">
          {this.printListItems()}
        </ul>
      </div>
    );
  }
}

export default ListComponent;